import { Component, OnInit } from '@angular/core';
import { UsuariosService } from '../../../services/usuarios.service';

@Component({
  selector: 'app-listar-usuarios',
  templateUrl: './listar-usuarios.component.html',
  styleUrls: ['./listar-usuarios.component.css']
})
export class ListarUsuariosComponent implements OnInit {
  titulo = 'Consulta de usuarios';
  usuarios:any=[];
  respuesta:any
  cadena:string[]=[]
  listUsuarios:any=[]
  pagina = 1;

  constructor(private usuariosService: UsuariosService) { }

  ngOnInit(): void {
    this.cargarUsuarios();

    $("#cancel").on("click", function() {
      $("#caja").val('');
    });
  }

  cargarUsuarios(): void{
    this.listUsuarios = []
    this.cadena=[]
    this.usuarios=[]
    this.usuariosService.traerUsuarios()
    .subscribe(resp => {
       this.respuesta = resp;
       this.listUsuarios = this.respuesta.data
       this.quitarDuplicados()
    });
  }

  borrar(): void{
    this.cargarUsuarios();
  }

  buscar(texto: string): void{
    this.listUsuarios=[]
    this.cadena=[]
    this.usuarios=[]
    this.usuariosService.traerUsuario(texto)
    .subscribe(resp => {
      this.respuesta = resp;
      this.listUsuarios = this.respuesta.data
      this.quitarDuplicados()
    });
  }

  quitarDuplicados(){
    let usuario:any
    this.cadena =[]
    this.listUsuarios.forEach((data: {
      idUsuario: string;
      nombreUsuario:string;
      email:string;
      perfil:string;
      area:string
    }) => {
    usuario={
      idUsuario:'',
      nombreUsuario:'',
      email:'',
      perfil:'',
      area:''
    }
    usuario.idUsuario = data.idUsuario
    usuario.nombreUsuario = data.nombreUsuario
    usuario.email=data.email
    usuario.perfil = data.perfil
    usuario.area = data.area
    if (!this.cadena.includes(data.idUsuario)) {
      this.usuarios.push(usuario);
      this.cadena.push(data.idUsuario);
    }
   });
  }



}
